import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactS3Uploader from 'react-s3-uploader';
import { Progress } from 'reactstrap';
import IconUploadVideo from 'images/upload_video.png';
import IconUploadImage from 'images/upload_image.png';
import apiClient from '../util/api-client';
import { showCapacityLimitPopup } from '../util/capacity-popup'; // FIX 20260724-uploadmsg
import { isMobileOrTablet } from "../util/common";
import * as MultipartUpload from '../util/multipart-upload';

const _10_GB = 10 * 1024 * 1024 * 1024;
const _100_MB = 100 * 1024 * 1024;
const _10_MB = 10 * 1024 * 1024;
const MIME_ALLOWED_UPLOAD_WITH_VIDEO_TYPE = ['video/mp4', 'video/avi', 'video/mov', 'video/x-ms-wmv', 'video/x-msvideo', 'video/quicktime'];
const MIME_ALLOWED_UPLOAD_WITH_WEB_TYPE = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf'];
const getAnimationUploaderModalId = (type = '') => (
  ['動画', 'video'].includes(type) ? 'animation-uploader-modal-video' : 'animation-uploader-modal-image'
);
const resolveModalEventId = (event) => (
  event?.detail?.modalId ||
  event?.target?.id ||
  event?.target?.querySelector?.('.modal-dialog[id]')?.id ||
  ''
);

export default class AnimationPublicUrlModal extends Component {
  constructor(props) {
    super(props);
    const { baseURL } = props;
    this.state = {
      completed: 0,
      time: 0,
      convert_file: false,
      finishConvert: false,
      showProgressBar: false,
      videoDuration: 0,
      pdfMetadata: null,
      progress: 0,
      fileUrl: null,
      isMultipart: false,
      multipartProgress: 0,
      parts: [],
    };
    this.concurrentUploads = this.props.isFreeOrLightPlan ? 1 : 3;
    this.onUploadProgress = this.onUploadProgress.bind(this);
    this.modalRef = React.createRef();
    this.apiClient = apiClient({ baseURL: baseURL || "/" });
  }

  handleModalBackClick = (e) => {
    const currentModalId = resolveModalEventId(e);
    if (!this.props.isOpen || currentModalId !== getAnimationUploaderModalId(this.props.type)) return;

    e.preventDefault();
    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    // Re-create apiClient if baseURL changes (e.g., when selecting another akaire_file)
    if (prevProps.baseURL !== this.props.baseURL) {
      this.apiClient = apiClient({ baseURL: this.props.baseURL || "/" });
    }
  }

  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.props.onClickClose();
    }
  };

  onUploadProgress(percent) {
    if (!this._uploadStarted) return;
    this.setState({showProgressBar: true})
    if(!this.state.convert_file){
      this.setState({ completed: percent })
    }
  }
  componentWillReceiveProps(nextProps) {
    const { statusConvert } = this.props
    if (nextProps.finishConvert !== this.state.finishConvert) {
      this.setState({ completed: 100 })
      statusConvert(false)
    }
    if (nextProps.completed !== this.state.completed) {
      setTimeout(() => {
        this.setState({ completed: 0, showProgressBar: false });
      }, 3000);
    }
    if (nextProps.isOpen !== this.props.isOpen) {
      if (!nextProps.isOpen && this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.setState({ completed: 0, showProgressBar: false });
      }
    }
  }
  calculateTime = (fileSize) => {
    var intervalTime = fileSize > _10_MB ? fileSize / 18000 : fileSize / 1800
    intervalTime = intervalTime > 3000 ? 3000 : intervalTime;
    this.intervalId = setInterval(() => {
      const { completed } = this.state;
      if (completed < 99) {
        this.setState({ completed: completed + 1 });
      }
    }, intervalTime);
  }

  onFinish = (signedUrlResult, filename) => {
    const { onFinish, convertVideo } = this.props;
    const { convert_file, videoDuration, pdfMetadata } = this.state
    filename = filename || this.fileInput.value.replace(/^.*[\\/]/, '');
    onFinish(signedUrlResult, filename, !!pdfMetadata ? pdfMetadata : videoDuration);
    if(convert_file){
      convertVideo(signedUrlResult, filename)
      this.setState({ convert_file: false })
    }
    this.fileInput.value = null;
    this.setState({ completed: 0, videoDuration: 0, pdfMetadata: null })
  }

  getNumberOfPagesPdf = (file) => {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
        reject(new DOMException("Problem parsing input file."));
      };

      reader.onloadend = () => {
        resolve(reader.result.match(/\/Type[\s]*\/Page[^s]/g)?.length || 1);
      }
      reader.readAsBinaryString(file);
    });
  }

  clearInputFileAndShowPopup(popupMessage, popupType = '') {
    $('.animation-uploader-modal input').val('');
    if (popupType === '') {
      Popup.alert(popupMessage, '', '', {kind: 'akaire'});
    } else {
      Popup.alert(popupMessage, popupType, '', {kind: 'akaire'});
    }
  }

  openPlanHeaderModal = () => {
    // FIX 20260724-uploadmsg 「チームのプランを更新」モーダルを直接開く
    if (window.Subscription && typeof window.Subscription.handleShowChangePlanHeaderModal === 'function') {
      window.Subscription.handleShowChangePlanHeaderModal();
      return;
    }
    const toggleBtn = $('#plan-header-toggle-btn');
    if(toggleBtn && toggleBtn.length > 0) {
      toggleBtn.trigger('click');
    }
    else {
      window.open(Routes.owner_total_info_path());
    }
  }

  // FIX 20260724-uploadmsg 容量超過モーダル（共通部品・全プラン対応／プラン変更ボタン付き）
  showOverCapacityPopup = () => {
    $('.animation-uploader-modal input').val('');
    $('#show-text-uploader-akaire').text('選択されていません').removeClass('font-weight-bold');
    showCapacityLimitPopup(this.props.uploadedDataInfo || {}, {
      onClose: () => { if (this.props.onClickClose) this.props.onClickClose(); }
    });
  }

  // FIX 20260724-uploadmsg 容量を超えるかの判定（選択直後に呼ぶ＝待たせない）
  isOverCapacity = (file) => {
    if (!file) return false;
    const { user: { total_file_size: totalFileSize, total_file_size_on_this_cycle: totalAllCycle,
      max_storage: maxStorage, total_file_size_limit: totalFileSizeLimit } = {}, uploadedDataInfo } = this.props;
    const { usedDataSize, maxUploadSize } = uploadedDataInfo || {};
    const fileSize = parseInt(file.size, 10);
    if (Number(usedDataSize) + fileSize > Number(maxUploadSize)) return true;
    if (fileSize + Number(totalAllCycle) > Number(totalFileSizeLimit)) return true;
    if (fileSize + Number(totalFileSize) > Number(maxStorage)) return true;
    return false;
  }

  preprocess = async (file, next) => {
    this._uploadStarted = true;
    const {
      onStart, convertFile, user: {total_file_size: totalFileSize,
      total_file_size_on_this_cycle: totalAllCycle,
      max_storage: maxStorage, total_file_size_limit: totalFileSizeLimit }, oneGb,
      uploadedDataInfo, currentLimitVideo, type: projectType, currentTotalSize,
      limitUploadPdf, limitUploadVideo, limitUploadImage
    } = this.props;
    const { type } = file;
    const { usedDataSize, maxUploadSize, membershipPlanName } = uploadedDataInfo;
    var file_size = parseInt(file.size);

    if (
        Shared.isVideoType(projectType) && !MIME_ALLOWED_UPLOAD_WITH_VIDEO_TYPE.includes(type) ||
        !Shared.isVideoType(projectType) && !MIME_ALLOWED_UPLOAD_WITH_WEB_TYPE.includes(type)
      ) {
      this.clearInputFileAndShowPopup('形式が異なる為、アップロードできません。');
      return;
    }

    if (currentTotalSize + file_size > _10_GB && membershipPlanName.includes('Free')) {
      this.clearInputFileAndShowPopup(`${membershipPlanName}プランのデータ容量（10 GB）を超過しました。`)
      return;
    }

    // FIX 20260724-uploadmsg 容量超過は共通モーダル（プラン変更ボタン付き）で案内する（保険）
    if (this.isOverCapacity(file)) {
      this.showOverCapacityPopup();
      return;
    }



    if (
      [
        "video/x-msvideo",
        "video/avi",
        "video/mov",
        "video/x-ms-wmv",
        "video/mp4",
        "video/quicktime",
      ].includes(type)
    ) {
      if (file_size > limitUploadVideo.size) {
        $('.animation-uploader-modal input').val('');
        const _msg = `1回での動画アップロード上限（${Shared.formatBytes(limitUploadVideo.size)}）<br>を超過した為、アップロードできません。`
        if (limitUploadVideo.is_plan_free_or_light) {
          Popup.confirm(_msg, {
            confirmText: 'プランを変更する',
            cancelText: '閉じる',
            success: () => { if (this.props.onClickClose) this.props.onClickClose(); this.openPlanHeaderModal() },
            cancel: () => { if (this.props.onClickClose) this.props.onClickClose(); },
            kind: 'akaire'
          })
        } else {
          Popup.confirm(_msg, {
            confirmText: '閉じる',
            cancelBtn: 'false',
            success: () => { if (this.props.onClickClose) this.props.onClickClose(); },
            kind: 'akaire'
          })
        }
        return;
      } else if (type != "video/mp4" && file_size <= _100_MB) {
        this.setState({ convert_file: true });
        convertFile(true);
      };
    }

    if (['image/png', 'image/jpeg', 'image/gif'].includes(type)) {
      if (file_size > limitUploadImage.size) {
        const maxSize = Shared.formatBytes(limitUploadImage.size);
        $('.animation-uploader-modal input').val('');
        // 画像は全プラン共通上限のためプラン変更ボタンなし（閉じるのみ）
        Popup.confirm(`1回での画像アップロード上限（${maxSize}）<br>を超過した為、アップロードできません。`, {
          confirmText: '閉じる',
          cancelBtn: 'false',
          success: () => { if (this.props.onClickClose) this.props.onClickClose(); },
          kind: 'akaire'
        })
        return;
      }
    }

    if (type == "application/pdf") {
      const numberOfPage = await this.getNumberOfPagesPdf(file);
      if (!(numberOfPage <= limitUploadPdf.page && file_size <= (limitUploadPdf.size))) {
        $('.animation-uploader-modal input').val('');
        const _pdfMsg = `1回でのPDFアップロード上限（${Shared.formatBytes(limitUploadPdf.size)}｜${limitUploadPdf.page}頁）<br>を超過した為、アップロードできません。<br>データ圧縮後、再度お試しください。`
        if (limitUploadPdf.is_plan_free_or_light) {
          Popup.confirm(_pdfMsg, {
            confirmText: 'プランを変更する',
            cancelText: '閉じる',
            success: () => { if (this.props.onClickClose) this.props.onClickClose(); this.openPlanHeaderModal() },
            cancel: () => { if (this.props.onClickClose) this.props.onClickClose(); },
            kind: 'akaire'
          })
        } else {
          Popup.confirm(_pdfMsg, {
            confirmText: '閉じる',
            cancelBtn: 'false',
            success: () => { if (this.props.onClickClose) this.props.onClickClose(); },
            kind: 'akaire'
          })
        }
        return;
      }

      const _heavyMB = 200 * 1024 * 1024;
      if (file_size > _heavyMB || numberOfPage > 100) {
        Popup.confirm(
          `アップロードを開始しました。<br>このPDFのアップロードには時間がかかる場合があります。<br>そのまましばらくお待ちください。`,
          { confirmText: 'OK', cancelBtn: 'false', success: () => {}, kind: 'akaire' }
        )
      }
      const _20_MB = 20 * 1024 * 1024;
      const isSmallPdf = file_size <= _20_MB && numberOfPage <= 50;
      this.setState({
        pdfMetadata: { isSmallPdf, numberOfPage }
      });
    }

    try {
      this._uploadStarted = true;
      onStart(file);

      const onProgressCallback = (progress) => {
        this.setState({ multipartProgress: progress });
        this.onUploadProgress(progress);
      };

      this.setState({ isMultipart: true, showProgressBar: true });

      const signedUrl = await MultipartUpload.performMultipartUpload(
        file,
        onProgressCallback,
        this.concurrentUploads,
      );

      const signedUrlResult = { signedUrl: signedUrl.url };
      this.onFinish(signedUrlResult, file.name);
      return;
    } catch (error) {
      console.error("Error during multipart upload:", error);
      this.setState({ isMultipart: false, showProgressBar: false });

      if (error && error.message === 'ABORTED_BY_USER') {
        this._uploadStarted = false;
        return;
      }

      Popup.alert(
        'アップロードに失敗しました。<br>もう一度お試しください。',
        'error',
        '',
        {kind: 'akaire'}
      );
    }
  }

  handleUpload = () => {
    if (!this.fileInput || !this.fileInput.value) {
      Popup.alert('何も選択されていません。', '', '', { kind: 'akaire', timer: 3000 });
      return;
    }

    const checkUploadNewPage = $('#uploadNewPagePopup').attr('data-upload-new') == 'true';
    const pageId = checkUploadNewPage ? 'new' : $('#uploadVersionPopup').attr('data-page-id');
    window._pdfAbortUpload = () => { try { if (MultipartUpload.requestMultipartAbort) MultipartUpload.requestMultipartAbort(); this.uploader && this.uploader.abort(); this._uploadStarted = false; this.setState({ completed: 0, showProgressBar: false }); } catch (e) {} };
    if (pageId === 'new' || pageId == undefined){
      this.uploader.uploadFile();
    }else {
      this.apiClient.get(`${pageId}/check_final_version`).then((response) => {
        if(response.data.is_has_final_version){
          Popup.confirm('現在、このページには最終稿バージョンが存在します。<br>新しいバージョンをアップロードすると、最終稿が解除されます。<br>アップロードしてよろしいですか？', {
            confirmText: 'OK',
            cancelBtn: false,
            success: () => {
              this.uploader.uploadFile();
            },
          });
        }else{
          this.uploader.uploadFile();
        }
      })
      .catch(() => {
        Popup.alert('画像のアップロードに失敗しました。');
      })
    }
  }

  getVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(video.duration);
      };

      video.onerror = () => {
        resolve(0);
      };

      video.src = URL.createObjectURL(file);
    });
  }

  handleFileChange = async (e) => {
    const file = e.target.files[0];
    // FIX 20260724-uploadmsg 選択した瞬間に容量を判定し、超過ならその場でモーダルを出して止める
    if (this.isOverCapacity(file)) {
      this.showOverCapacityPopup();
      return;
    }
    const fileName = file.name;
    $('#show-text-uploader-akaire').text(fileName);
    $('#show-text-uploader-akaire').addClass('font-weight-bold');

    if (file && MIME_ALLOWED_UPLOAD_WITH_VIDEO_TYPE.includes(file.type)) {
      try {
        const duration = await this.getVideoDuration(file);
        this.setState({ videoDuration: duration });
      } catch (error) {
        console.error('Error getting video duration:', error);
      }
    }
  }

  redirectToUploadMultipleFile = () => {
    const path = window.location.search
    window.location.href = window.location.origin + `/akaire_feature/akaires/upload_multiple_files${path}`
  }

  render() {
    const { baseURL, projectId, isOpen, onClickClose, onStart, onFinish, onError, type, onClickInputFile, is_mobile , isUploadMultipleFiles} = this.props;
    const { completed, showProgressBar } = this.state
    const modalId = getAnimationUploaderModalId(type);
    var title = '';
    var progressBar = '';
    let divText = '';
    var icon_popup = '';
    if (['動画', 'video'].includes(type)) {
      title = 'YouTube動画を赤入れする';
      icon_popup = (IconUploadVideo)
      divText = !is_mobile ? (<div className="font-size-14px mt-3 text-primary font-size-12px-sp">
                  <span>※動画アップロードする場合、</span><div></div>
                  <span>WMV・AVI・MOV形式データは「MP4形式」で保存されます。</span><br />
                  <span>アップロード後、WMV・AVI形・MOV式でダウンロードする場合は</span><br />
                  <span>指定のファイル形式でダウンロード してください。</span><br />
                </div>) : (
                  <div className="font-size-14px mt-2 font-weight-bold font-size-12px-sp">
                    <span>現在表示可能な動画形式は WMV / AVI / MP4 / MOVになります。</span>
                  </div>
                )
    }
    else {
      title = '画像またはPDFを校正する';
      icon_popup = (IconUploadImage)
      divText = <div className="black-text mt-3">
                   <span>※現在表示可能な画像形式は PDF / JPG / PNG / GIFになります。</span>
                </div>
    }
    if (showProgressBar) {
      const { isMultipart, multipartProgress, completed } = this.state;
      const completedValue = isMultipart ? Math.round(multipartProgress) : completed;
      progressBar = (
        <Progress value={completedValue}>
          {`${completedValue}%`}
        </Progress>
      )
    }
    return (
      <Modal isOpen={isOpen} toggle={onClickClose} ref={node => (this.modalRef = node)} className="animation-uploader-modal modal-dialog-centered modal-style additional-akaire" id={modalId} onClosed={this.props.onClosed}>
        <ModalBody style={{padding: '0px'}}>
          <div className='justify-content-center text-center modal-header' style={{paddingBottom: '10px'}}>
            <span className='additional-akaire-title'>
              <img className="icon-upload filter-black-icon" src={icon_popup} alt="アップロード" width="50" />
              {['動画', 'video'].includes(type) ? '動画データを校正する' : '画像またはPDFを校正する'}</span>
          </div>
          {progressBar}
          <div className="align-center-div mt-4" style={{padding: isMobileOrTablet() ? "0px 20px 0px 20px": "inherit" }}>
            <label className="btn btn-default btn-file btn-file-upload-akaire-page w-140px">
            ファイルを選択
            <ReactS3Uploader
              preprocess={this.preprocess}
              onProgress={this.onUploadProgress}
              signingUrl={`${baseURL}/animations/new`}
              accept={['動画', 'video'].includes(type) ? "video/mp4,video/mov,video/avi,video/x-ms-wmv,video/quicktime,video/x-msvideo" : "image/png,image/jpeg,image/gif,application/pdf"}
              uploadRequestHeaders={{ 'x-amz-acl': 'private' }}
              onFinish={this.onFinish }
              inputRef={_ => this.fileInput = _}
              onClick={ () => onClickInputFile() }
              autoUpload={false}
              scrubFilename={(filename) => filename.replace(/[^\w\d_\-.]+/ig, '')}
              ref={uploader => { this.uploader = uploader; }}
              onChange={this.handleFileChange}
            />
            </label>
            <span id="show-text-uploader-akaire" className="ml-2 text-black">選択されていません</span>
            { !!isUploadMultipleFiles && ['動画', 'video'].includes(type) ?
              (<div className="mt-2">
                <label className="btn btn-default btn-file w-140px btn-file-upload-akaire-page" onClick={this.redirectToUploadMultipleFile}>複数データを選択</label>
                <span id="show-text-uploader-akaire-2" className="ml-2 text-black">選択されていません</span>
              </div>) : ('')
            }
            { divText }
          </div>
          <div className="additional-akaire-button text-center">
            <Button color="primary" className="px-4 py-2 border-radius-7px" onClick={this.handleUpload}>Uploadする</Button>
            <Button color="secondary" className="text-dark btn-button-close px-4 py-2 border-radius-7px" onClick={onClickClose}>閉じる</Button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
};
